import { IconButton } from "@fluentui/react";
import { Flex, Loader, Text } from "@fluentui/react-northstar";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import RubricSection from "./RubricSection";

const Rubric = (props) => {
  const {
    user,
    currentAssignmentData,
    rubricData,
    havePoints,
    isLoading,
    selectedLevels,
    t,
  } = props;

  const { assignmentId, subjectCode } = useParams();
  const history = useHistory();

  const translation = t("assignment").body;
  const rubricPageTranslation = translation.rubricPage;

  return (
    <div
      className="student-rubric p-2"
      style={{ marginTop: "10px", marginBottom: "15px" }}
    >
      <Flex vAlign="center" style={{ marginLeft: "5px", marginTop: "10px" }}>
        <IconButton
          iconProps={{ iconName: "ChromeBack" }}
          title={translation.back}
          ariaLabel={translation.back}
          onClick={() => {
            history.push({
              pathname: `/assignments/${subjectCode}/assignments/${assignmentId}`,
            });
          }}
        />
        <Text
          color="brand"
          size="large"
          weight="semibold"
          style={{ marginRight: "10px" }}
        >
          {rubricPageTranslation.backToAssignment}
        </Text>
      </Flex>
      {isLoading ? (
        <Loader size="medium" />
      ) : rubricData?.length ? (
        <RubricSection {...{ rubricData, havePoints, selectedLevels }} />
      ) : (
        <div>
          <Flex fill hAlign="center" style={{ marginTop: "50px" }}>
            <Text weight="regular" size="large">
              {rubricPageTranslation.noRubricDataAvailable}
            </Text>
          </Flex>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(Rubric);
